export default __webpack_public_path__ + "static/media/help1.65f1447b.svg";